'use client'
import { cn } from '@/shared/lib/classnames'
import { useThemeConfig } from '../model/store/theme-config'
import { useTheme } from 'next-themes'
import { selectThemeConfig } from '../model/selectors/theme'
import { DefaultThemes } from '@/shared/config/theme/lib/theme'
import { Button } from '@/ui/button'
import { Moon, Sun } from 'lucide-react'
// import { ButtonProps } from 'react-day-picker'

interface PropsTheme {
  theme?: 'light' | 'dark'
}

export function ThemeModeToggle({ theme }: PropsTheme) {
  const { theme: currentTheme, setTheme } = useTheme()
  const mode = useThemeConfig(selectThemeConfig)
  const dark = mode.dark || DefaultThemes['dark']
  const light = mode.light || DefaultThemes['light']

  const isActive = (theme === 'light' && currentTheme === light) || (theme === 'dark' && currentTheme === dark)

  const handleClick = () => {
    if (theme === 'light') {
      setTheme(light)
    } else {
      setTheme(dark)
    }
  }

  return (
    <div className="w-full h-full">
      <Button
        variant={isActive ? 'defaultGhost' : 'ghost'}
        size="icon"
        onClick={handleClick}
        className={cn(
          'h-14 w-full rounded-md focus:outline-none',
          'focus:outline-none focus:ring-0 focus:ring-offset-0', // убираем фокус
          'focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0', // убираем видимый фокус
          isActive && 'border-primary border-2',
          !isActive && 'opacity-70',
        )}
      >
        {theme === 'light' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        <span className="sr-only">Toggle theme</span>
      </Button>
    </div>
  )
}
